//@ts-nocheck
/*
 *  This file shared.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from './http-service';

import { ConfirmationService } from 'primeng/api';
import { SnackbarAlertService } from './snackbar-alert.service';

import { DatePipe, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { has } from 'lodash';
import { ConfigurationService } from './configuration.service';
import { formIds } from '../constants/forms.contant';
import { Observable } from 'rxjs';

@Injectable()
export class SharedService {
  profile: string = '';
  callNewFlow = true;
  public validationMessages = {
    maxHour: 'Hours should not be greater than 23 !',
    maxMin: 'Minutes should not be greater than 59 !',
    hours: 'Only one digit is allowed after decimal',
    required: 'This field should not be left blank',
    numericOnly: 'Please enter only numeric digits.',
    numericDecimal: 'Please enter decimal numeric digits.',
    alphabetOnly: 'Please enter alphabets only.',
    alphaNumericOnly: 'Please enter only alphanumeric characters',
    allowedCharacters: "a-z, A-Z, 0-9 and (_ @ # $ % & () *.', - ? / : ; ! |) characters are allowed",
    blankSpace: 'Blank spaces are not allowed.',
    spaceNotAllowed: 'Space is not allowed',
    zeroOnlyNotAllowed: 'Zero is not allowed',
    maxLength: 'The maximum character limit is',
    minLength: 'The minimum character limit is',
    maxNumberLength: 'The maximum value allowed is',
    minNumberLength: 'The minimum value allowed is',
    maxLength20: 'Maximum 20 characters are allowed',
    maxLength40: 'Maximum 40 characters are allowed',
    maxLength500: 'Maximum 500 characters are allowed',
    duplicate: 'This code series already exists. Please select a new one and try again.',
    invalidEmail: 'This is not a valid email. Please enter a valid one and try again.',
    invalidWebsite: 'This is not a valid website. Please enter a valid one and try again.',
    validDate: 'This is not a valid date. Please enter a valid date and try again.',
    invalidTime: 'This is not a valid time. Please enter a valid time and try again.',
    invalidDuration: 'This is not a valid duration. Please enter a valid duration and try again.',
    numericOrDecimal: 'Invalid input', //'This is not a valid number.Please enter a valid one and try again.', changed after disccus with meghna bug id ---- 30108
    parAccessDenied: "You do not have permission. Please contact your administrator.",
    parView: "You do not have permission to view. Please contact your administrator.",
    parAdd: "You do not have permission to add. Please contact your administrator.",
    parEdit: "You do not have permission to edit. Please contact your administrator.",
    parUpdate: "You do not have permission to update. Please contact your administrator.",
    parDelete: "You do not have permission to delete. Please contact your administrator.",
    parRemove: "You do not have permission to remove. Please contact your administrator.",
    parInactivate: "You do not have permission to inactivate. Please contact your administrator.",
    pan: 'This is not a valid PAN number.',
    passport: 'This is not a valid passport no. Please enter a valid one and try again.',
    passregex: 'Password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
    aadhar: 'This is not a valid aadhar card number. Please enter a valid one and try again.',
    autoComplete: 'This is not a valid input. Please search a valid one.',
    lessFromDate: 'This date cannot be less than from date.',
    lessStartDate: 'This date cannot be less than start date.',
    valueGreaterThan: 'The value should be greater than',
    invalidRange: 'Duration of date search should be 90 days',
    bothDate: 'Please select both From and To date ',
    SSOIdRegx: 'a-z, A-Z, 0-9 and (_ @ . -) characters are allowed',
    paytmWallet: 'This is not a valid wallet id. Please enter a valid one and try again',
    ipAddressInvalid: 'please enter valid Ip address',
    isValidUrl: 'please enter valid url',
    numberRange: 'Please enter the digit between 1 to 6',
    allowedCharactersWithApostrophe: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! | ') characters are allowed",
    invalidLatitude: 'Invalid latitude',
    invalidLongitude: 'Invalid longitude',
    invalidFromToInput: 'Invalid range',
    mobile: 'This is not a valid number!',
    specialCharacterOnly: 'Only special characters are allowed',
    numericAndSpecialCharacter: 'Numeric and special characters are allowed',
    specialCharacterAndAlphabet: 'Special character and alphabet are allowed',
    maximumHrs: 'The maximum hour limit is',
    fileName: 'This file name is invalid. Use only letters, numbers, and the special characters [ ] and _',
    allowedAllCharactersExceptSpace: 'space is not allowed',
    allowedCharactersWithoutQuotes: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! |) characters are allowed",
    allowedCharactersWithoutQuotesWithBrackets: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! | [] \" + = < >) characters are allowed"
  };
  formIds = formIds;
  companyDetails = {
    favicon: this._config.configData?.isDeployOnGT ? 'assets/images/dynamic_images/favicon.ico' : 'assets/images/dynamic_images/favicon_hrone.ico',
    title: this._config.configData?.isDeployOnGT ? 'HRMS' : 'HROne',
  };
  isCurrentEmployeePriviledged: boolean = false;
  minAllowedDate = new Date('1753-01-01');

  constructor(
    public _httpService: HttpService,
    public router: Router,
    public _snackBar: SnackbarAlertService,
    public _confirmDialog: ConfirmationService,
    public _sanitizer: DomSanitizer,
    public _config: ConfigurationService,
    public datepipe: DatePipe,
    public _httpClient: HttpClient,
    public _location: Location
  ) {
    this.setBgClass();
  }

  compareMultiselectFn(a: any, b: any) {
    return a && b && a.id === b.id;
  }
  compareMultiselectFn2(a: any, b: any) {
    return a && b && a.Id === b.Id;
  }
  compareMultiselectFn3(a: any, b: any) {
    return a && b && a.Key === b.Key;
  }
  compareMultiselectFn4(a: any, b: any) {
    return a && b && a.key === b.key;
  }
  compareMultiselectFn5(a: any, b: any) {
    return a && b && a === b;
  }
  compareMultiselect(a: any, b: any) {
    return a && b && a.key === b.key;
  }
  compareMultiselectPlain(a: any, b: any) {
    return a && b && a === b;
  }

  compareMultiselectFnForObject(a: any, b: any) {
    return a && b && JSON.stringify(a) === JSON.stringify(b);
  }

  convertFormGroupNullValueToEmptyString(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      if (formGroup.get(key)?.value === null) {
        formGroup.get(key)?.setValue('');
      }
    });
  }

  convertNullToEmptyString(data: any) {
    Object.keys(data).forEach(key1 => {

      if (data[key1] === null) {
        data[key1] = '';
      } else if (Array.isArray(data[key1])) {
        for (const item of data[key1]) {
          Object.keys(item).forEach(key2 => {
            if (item[key2] === null) {
              item[key2] = '';
            }
          });
        }
      } else if (typeof data[key1] === 'object' && data[key1] !== null) {
        Object.keys(data[key1]).forEach(key2 => {
          if (data[key1][key2] === null) {
            data[key1][key2] = '';
          }
        });
      }

    });
  }

  dateChange(control: AbstractControl) {
    if (!control.value) {
      control.setValue('');
    }
    control.updateValueAndValidity();
  }

  private compareArrays(newArray: any[], preArray: any[]): boolean {
    if (newArray.length !== preArray.length) {
      return true;
    }
    for (let i = 0; i < newArray.length; i++) {
      if (this.compareFormData(newArray[i], preArray[i], true)) {
        return true;
      }
    }
    return false;
  }

  private compareObjects(newItem: any, preItem: any): boolean {
    return this.compareFormData(newItem, preItem, true);
  }

  private comparePrimitives(newValue: any, preValue: any, newData: any, preData: any, key: string): boolean {
    if (typeof newValue === 'string') {
      newData[key] = newValue.trim();
      newValue = newData[key];
    }
    if (typeof preValue === 'string') {
      preData[key] = preValue.trim();
      preValue = preData[key];
    }
    return (newValue || preValue) && (newValue !== preValue);
  }

  compareFormData(newData: any, preData: any, isRecursive?: boolean): boolean {
    if (!preData) {
      return true;
    }

    try {
      const keys = Object.keys(newData);
      for (const key of keys) {
        if (!has(preData, key)) {
          continue;
        }

        const newValue = newData[key];
        const preValue = preData[key];

        let isChanged = false;
        if (Array.isArray(newValue) && Array.isArray(preValue)) {
          isChanged = this.compareArrays(newValue, preValue);
        } else if (typeof newValue === 'object' && newValue !== null && typeof preValue === 'object' && preValue !== null) {
          isChanged = this.compareObjects(newValue, preValue);
        } else {
          isChanged = this.comparePrimitives(newValue, preValue, newData, preData, key);
        }

        if (isChanged) {
          return true;
        }
      }

      if (!isRecursive) {
        this._snackBar.Alert('Please fill some data', '3');
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  getAppVersion() {
    this._httpService.GetWithoutHeader('/api/Default/ApplicationVersion').subscribe((response: any) => {
      if (response?.length) {
        const localV = localStorage.getItem('versionId');
        localStorage.setItem('versionId', response[0].versionId);
        if (localV && localV != response[0].versionId) {
          location.reload();
        }
      }
    });
  }

  getVerificationStatus(key: string, value: any, bgvVerificationDetails: any[]): string {
    if (!bgvVerificationDetails.length) {
      return '2';
    }
    const verDetail = bgvVerificationDetails.filter(det => det.originalFieldName === key);
    if (key == 'DOB' && value) {
      value = this.datepipe.transform(value, 'yyyy-MM-dd');
    }

    if (verDetail.length) {
      const verifiedFromAadhar = verDetail.find(det => (det.aadhaarKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromPan = verDetail.find(det => (det.panKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromBankAccount = verDetail.find(det => (det.bankAccountKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromDL = verDetail.find(det => (det.dlKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      if (verifiedFromAadhar || verifiedFromPan || verifiedFromBankAccount || verifiedFromDL) {
        return '0';
      } else if (!verDetail[0].aadhaarKycFieldValue && !verDetail[0].panKycFieldValue && !verDetail[0].bankAccountKycFieldValue && !verDetail[0].dlKycFieldValue) {
        return '2';
      } else {
        return '1';
      }
    } else {
      return '2';
    }
  }

  private normalizeValue(value: string): string {
    return (value || '').toString().trim().toLowerCase();
  }

  private findVerificationSource(verDetail: any[], value: string, fieldName: string): boolean {
    return verDetail.some(det => this.normalizeValue(det[fieldName]) === this.normalizeValue(value));
  }

  private getVerificationSources(verDetail: any[], value: string) {
    return {
      aadhar: this.findVerificationSource(verDetail, value, 'aadhaarKycFieldValue'),
      pan: this.findVerificationSource(verDetail, value, 'panKycFieldValue'),
      bankAccount: this.findVerificationSource(verDetail, value, 'bankAccountKycFieldValue'),
      dl: this.findVerificationSource(verDetail, value, 'dlKycFieldValue')
    };
  }

  private getTooltipMessage(sources: { aadhar: boolean; pan: boolean; bankAccount: boolean; dl: boolean }): string {
    if (sources.aadhar && sources.pan) {
      return 'Fetched from Aadhar,PAN';
    }
    if (sources.aadhar) {
      return 'Fetched from Aadhar';
    }
    if (sources.pan) {
      return 'Fetched from PAN';
    }
    if (sources.bankAccount) {
      return 'Fetched from Bank Account';
    }
    if (sources.dl) {
      return 'Fetched from DL';
    }
    return 'Not available';
  }

  private hasAnyKycField(verDetail: any[]): boolean {
    const first = verDetail[0];
    return !!(first?.aadhaarKycFieldValue || first?.panKycFieldValue || first?.bankAccountKycFieldValue || first?.dlKycFieldValue);
  }

  private getUnverifiedMessage(verDetail: any[]): string {
    const first = verDetail[0];
    const unverifiedValue = first?.aadharValue || first?.panValue || first?.bankAccountValue || first?.dlValue || '';
    return `Not verified: ${unverifiedValue}`;
  }

  getVerificationTooltip(key: string, value: any, bgvVerificationDetails: any[]): string {
    if (!value) {
      return '';
    }
    if (!bgvVerificationDetails.length) {
      return 'Not available';
    }

    const verDetail = bgvVerificationDetails.filter(det => det.originalFieldName === key);
    if (!verDetail.length) {
      return 'Not available';
    }

    let normalizedValue = value;
    if (key === 'DOB' && value) {
      normalizedValue = this.datepipe.transform(value, 'yyyy-MM-dd');
    }

    const sources = this.getVerificationSources(verDetail, normalizedValue);
    const hasAnySource = sources.aadhar || sources.pan || sources.bankAccount || sources.dl;

    if (hasAnySource) {
      return this.getTooltipMessage(sources);
    }

    if (!this.hasAnyKycField(verDetail)) {
      return 'Not available';
    }

    return this.getUnverifiedMessage(verDetail);
  }

  get isDeployedOnGT(): boolean {
    return Boolean(this._config.configData && this._config.configData.isDeployOnGT);
  }

  getUserThemeFromStorage(): TUserThemeInStorage {
    localStorage.removeItem('selectedThemeColorIndex');
    const theme: string = localStorage.getItem('selectedTheme') ?? '';
    let userThemeFromStorage: TUserThemeInStorage = theme ? JSON.parse(theme) : { default: 0, user: null, hr: null };
    let count = 0;
    while (typeof userThemeFromStorage === 'string' && count < 10) {
      userThemeFromStorage = JSON.parse(userThemeFromStorage);
      count++;
    }
    return userThemeFromStorage;
  }

  getCurrentThemeId(): number {
    const userThemeFromStorage: TUserThemeInStorage = this.getUserThemeFromStorage();
    let colorIndex = 0;
    if (userThemeFromStorage.user) {
      colorIndex = userThemeFromStorage.user;
    }
    else if (userThemeFromStorage.hr) {
      colorIndex = userThemeFromStorage.hr;
    }
    return colorIndex;
  }

  setBgClass(): void {
    let colorIndex = this.getCurrentThemeId();
    colorIndex = colorIndex > THEME_LIST.length ? 0 : colorIndex;
    const userThemeFromStorage: TUserThemeInStorage = this.getUserThemeFromStorage();
    this.setThemeToStorage(userThemeFromStorage);
    const newbgClass = THEME_LIST[colorIndex];
    const finalclass = Object.keys(newbgClass)[0];
    if (document.body.classList.contains('myycolor')) {
      document.body.removeAttribute('class');
    }
    document.body.setAttribute('class', finalclass)

  }
  setThemeToStorage(userThemeFromStorage: TUserThemeInStorage) {
    localStorage.setItem('selectedTheme', JSON.stringify(userThemeFromStorage));
  }

  isOneAIExternalAvailable(featureId: number, appId: string, domainCode: string, isNewFlow = false): Promise<boolean> {
    const postMethod: 'PostUnauthorizedWithAppId' | 'oldPostUnauthorizedWithAppId' = (isNewFlow && this.callNewFlow) ? 'PostUnauthorizedWithAppId': 'oldPostUnauthorizedWithAppId';
    return new Promise((resolve, reject) => {
      this._httpService[postMethod]('/api/external/customer/FeatureLicense/Details', appId, domainCode, { featureId: featureId }).subscribe({
        next: (res) => {
          if (res?.activeStatus) {
            resolve(true)
          } else {
            resolve(false)
          }
        }, error: () => {
          reject(new Error('false'))
        }
      })
    })
  }

  isOneAIExternalfeatureAvailable(featureId: number, oneAIFeatureId: number, appId: string, domainCode: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let method =  this.callNewFlow ? 'GetUnauthorizedWithAppId': 'oldGetUnauthorizedWithAppId'
      this._httpService[method](`/api/external/OneAI/feature?featureId=${featureId}&oneAIFeatureId=${oneAIFeatureId}`, appId, domainCode).subscribe({
        next: (res) => {
          if (res?.isActive) {
            resolve(true)
          } else {
            resolve(false)
          }
        }, error: () => {
          reject(new Error('false'))
        }
      })
    })
  }

  //Replaces special characters with standard equivalents
  sanitizeText(text: string): string {
    if (!text || typeof text !== 'string') {
      return text;
    }
    return text
      .replace(/\u2019/g, "'")  // Replace RIGHT SINGLE QUOTATION MARK with single quote
      .replace(/\u2018/g, "'")  // Replace LEFT SINGLE QUOTATION MARK with single quote
      .replace(/\u201C/g, '"')  // Replace LEFT DOUBLE QUOTATION MARK with double quote
      .replace(/\u201D/g, '"')  // Replace RIGHT DOUBLE QUOTATION MARK with double quote
      .replace(/\u2013/g, '-')  // Replace EN DASH with hyphen
      .replace(/\u2014/g, '-'); // Replace EM DASH with hyphen
  }
  generateOTP(apiId:string, domainCode:string,param:any,captch?:string):Observable<any>{
   return this._httpService.PostUnauthorizedWithAppId('/api/candidate/auth/otp/generate',apiId,domainCode,param, true,captch)
  }
  verifyOTP(apiId:string, domainCode:string, param:{sessionId:string;otp:string}, captch?:string):Observable<any>{
   return this._httpService.PostUnauthorizedWithAppId('/api/candidate/auth/otp/verify', apiId, domainCode, param, false,captch);
  }
  logoutUser(domainCode:string,apikey?:string = '',onLoggedOut?:()=>void):void{
    this._httpService.PostUnauthorizedWithAppId('/api/candidate/auth/logout',apikey,domainCode,{}).subscribe({
      next:(res)=>{
        this.clearLocalStorage();
        onLoggedOut?.();
      }
    });
  }
  decodeBase64(cid: string): string {
    return atob(cid)
  }
  encodeBase64(mob: string): string {
    return btoa(mob);
  }
  isLogin(): boolean {
    return !!localStorage.getItem('domainCode') && !!localStorage.getItem('mob');
  }
  clearLocalStorage():void{
     localStorage.removeItem('mob');
      localStorage.removeItem('domainCode');
      localStorage.removeItem('kycId');
  }
}

export type TUserThemeInStorage = { default: number, user: number, hr: number };

export const THEME_LIST: Array<{ [key: string]: string }> = [
  { lightTheme: '#02563D' },
  { steelBlueTheme: '#237DD1' },
  { oxfordBlueTheme: '#1D2435' },
  { ultraVioletTheme: '#645788' },
  { purpureusTheme: '#A7205C' },
  { cyanGreenTheme: '#12C4AC' },
  { crayolaTheme: '#e6793b' }
];